import { authenticatedApi } from '../../../shared/api/apiClientUtils.ts';

export interface SiteAssignmentDto {
  siteId: number;
  siteName: string;
  what3WordsAddress?: string;
  assignedAt: string;
  assignedByUserId: string;
  assignedByUserEmail: string;
}

export interface AssignUserToSitesRequest {
  siteIds: number[];
}

export interface AssignUserToSitesResponse {
  userId: string;
  assignments: SiteAssignmentDto[];
}

export interface GetUserSiteAssignmentsResponse {
  assignments: SiteAssignmentDto[];
}

/**
 * Get all site assignments for a specific user
 * Backend returns array directly, we wrap it for consistency
 */
export const getUserSiteAssignments = async (
  userId: string
): Promise<SiteAssignmentDto[]> => {
  const response = await authenticatedApi.get<SiteAssignmentDto[]>(
    `/api/v1/users/${userId}/sites`
  );
  return response.data;
};

/**
 * Bulk assign a user to multiple sites
 * Passing an empty array removes all assignments
 */
export const assignUserToSites = async (
  userId: string,
  siteIds: number[]
): Promise<AssignUserToSitesResponse> => {
  const response = await authenticatedApi.put<AssignUserToSitesResponse>(
    `/api/v1/users/${userId}/sites`,
    { siteIds } satisfies AssignUserToSitesRequest
  );
  return response.data;
};

/**
 * Remove user from a specific site
 */
export const removeUserFromSite = async (
  userId: string,
  siteId: number
): Promise<void> => {
  await authenticatedApi.delete(`/api/v1/users/${userId}/sites/${siteId}`);
};
